var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('issue-permit',{attrs:{"open":_vm.dialogOpen,"dialog-title":"Request Permit","isRequestedByARO":true},on:{"update:open":function($event){_vm.dialogOpen=$event},"reloadAllPermits":_vm.onReloadPermits}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }